import { useEffect, useRef } from "react";

/** True while a page change is in flight (not background refresh on same page). */
export function useLeaderboardPageTransition(page, isFetching, isLoading, hasData) {
  const fetchedPageRef = useRef(page);

  const pageTransition =
    isFetching && (isLoading || !hasData || fetchedPageRef.current !== page);

  useEffect(() => {
    if (!isFetching && hasData) {
      fetchedPageRef.current = page;
    }
  }, [isFetching, hasData, page]);

  return pageTransition;
}

export function prefetchLeaderboardPage(dispatch, api, { productId, playToken, page, pageSize }) {
  if (!productId || !playToken) return;
  dispatch(
    api.endpoints.getPlayTableHistory.initiate(
      { productId, playToken, page, pageSize },
      { subscribe: false }
    )
  );
}
